import {Button, Modal} from "antd";
import React, {Component} from "react";
import UserForm from "./UserForm";
import User, {UserFormData} from "../../types/User";
import {FormType} from "../../types/FormType";
import UserService from "../../services/UserService";
import {errorNotification, successNotification} from "../../services/NotificationService";
import {AxiosError} from "axios";
import styles from "../../theme/Dialog.module.css";

interface ValidationErrorResponse {
    errors?: { defaultMessage?: string }[]
}

interface TeamMemberDialogProps {
    type: FormType
    roles: string[]
    user?: User
    onClose: () => void
}

export default class TeamMemberDialog extends Component<TeamMemberDialogProps> {

    private userFormRef = React.createRef<UserForm>();

    state = {isLoading: false}

    submit = () => {
        this.userFormRef.current?.formRef.current?.submit()
    }

    handleUserFormData = (userFormData: UserFormData) => {
        this.setState({isLoading: true})
        if (FormType.CREATE === this.props.type) {
            this.createUser(userFormData)
        } else if (FormType.EDIT === this.props.type) {
            this.updateUser(userFormData)
        }

    }

    createUser = (userFormData: UserFormData) => {
        UserService.createUser(userFormData).then(() => {
            UserService.loadUsers()
            successNotification(`${userFormData.username} added`, "They can sign in now.")
            this.setState({isLoading: false})
            this.props.onClose()
        }).catch((reason: AxiosError<ValidationErrorResponse>) => {
            const errorMessage = this.errorMessageOrDefault(userFormData, reason)
            errorNotification(errorMessage)
            this.setState({isLoading: false})
        })
    }

    errorMessageOrDefault = (userFormData: UserFormData, reason: AxiosError<ValidationErrorResponse>) => {
        return reason.response?.data?.errors?.[0]?.defaultMessage || `${userFormData.username} couldn't be added. Try again.`;
    }

    updateUser = (userFormData: UserFormData) => {
        UserService.updateUser(userFormData, this.props.user?.id as string).then(() => {
            UserService.loadUsers()
            successNotification(`${userFormData.username} is updated`)
            this.setState({isLoading: false})
            this.props.onClose()
        }).catch(reason => {
            console.error(reason)
            errorNotification(`${userFormData.username} couldn't be updated. Try again.`)
            this.setState({isLoading: false})
        })
    }

    render() {
        const isCreate = FormType.CREATE === this.props.type;
        return <Modal
            title={isCreate ? "Add member" : `Edit ${this.props.user?.username}`}
            open
            onCancel={() => !this.state.isLoading && this.props.onClose()}
            centered
            width="min(480px, calc(100vw - 24px))"
            mask={{closable: false}}
            destroyOnHidden
            className={styles.dialog}
            footer={
                <div className={styles.footerActions}>
                    <Button onClick={this.props.onClose} disabled={this.state.isLoading}>Cancel</Button>
                    <Button type="primary" loading={this.state.isLoading} onClick={this.submit}>
                        {isCreate ? "Add member" : "Save changes"}
                    </Button>
                </div>
            }
        >
            <UserForm
                user={this.props.user}
                roles={this.props.roles}
                onUserFormData={this.handleUserFormData}
                ref={this.userFormRef}/>
        </Modal>
    }
}
